import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Login } from "../../assets/comman/index";
import { FaEye, FaEyeSlash } from "react-icons/fa"; 
import { fetchLoggedUser } from "../../redux/actions/loggedUserActions";
import { useDispatch } from "react-redux";
import axios from "axios";
const Base_Url = process.env.REACT_APP_BASE_URL;
export default function LoginPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });

  const [showPassword, setShowPassword] = useState(false); 
  const dispatch=useDispatch();
  
  const handleSubmit = async(e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${Base_Url}/api/auth/login`, {
        email: formData.email,
        password: formData.password,
        role: "CUSTOMER"
      });
      const {message,data} = res.data
      const user = {
        id:data.id,
        role: data.role,
        name: data.name,     
      };
      dispatch(fetchLoggedUser());
      localStorage.setItem("token", data.token);
      localStorage.setItem("customeruser", JSON.stringify(user));
      toast.success(message||"Login successful!");
      navigate("/");
      } 
      catch (err) 
      {
        if (err.response && err.response.data && err.response.data.message) {
          toast.error(err.response.data.message);
        } else {
          toast.error("Login failed. Try again!");
        }
        console.error("Login error:", err);
      }
    
  };

  return (
    <div className="min-h-screen bg-gray-100 px-8 md:px-14 xl:px-20 py-8">
      <h2 className="text-lg md:text-2xl xl:text-3xl font-bold mb-5 text-center">LOGIN</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 xl:gap-16">
        <div className="order-2 md:order-1">
          <img src={Login} alt="loginImage" className="w-full h-96 md:h-[390px] xl:h-[500px] object-cover" />
        </div>

        <div className="order-1 md:order-2 bg-gradient-to-br from-violet-400 to-gray-100 rounded-tl-3xl rounded-bl-[100px] md:rounded-bl-[130px] xl:rounded-bl-[200px] px-6 xl:px-8 py-10 md:py-10 xl:py-14 w-full max-w-md">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-3">
                Email ID / Phone Number
              </label>
              <input
                type="text"
                placeholder="Enter your Email/Phone number"
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-pink-400"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-3">
                Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={(e) =>
                    setFormData({ ...formData, password: e.target.value })
                  }
                  className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-pink-400 pr-10"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-2.5 text-gray-600"
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>

            <div className="flex justify-center pt-10 md:pt-14 xl:pt-20">
              <button
                type="submit"
                className="px-5 bg-violet-700 text-white font-semibold py-2 rounded hover:bg-violet-800"
              >
                LOGIN
              </button>
            </div>
          </form>


          <div className="text-right text-xs md:text-sm mt-1 font-bold">
              <button 
                  onClick={()=>navigate("/forgetpassword")}
                  className="text-pink-600 hover:underline"
              >
                  Forgot Password?
              </button>
          </div>
          <p className="text-xs md:text-sm xl:text-base my-4 text-center font-bold">
            Don’t have an account?{" "}
            <a href="/signup" className="text-blue-700 font-semibold hover:underline">
              Signup Here
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
